import { render } from "./AddTeamPage.vue?vue&type=template&id=041e6958&scoped=true"
import script from "./AddTeamPage.vue?vue&type=script&lang=ts"
export * from "./AddTeamPage.vue?vue&type=script&lang=ts"

import "./AddTeamPage.vue?vue&type=style&index=0&id=041e6958&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-041e6958"
/* hot reload */
if (module.hot) {
  script.__hmrId = "041e6958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('041e6958', script)) {
    api.reload('041e6958', script)
  }
  
  module.hot.accept("./AddTeamPage.vue?vue&type=template&id=041e6958&scoped=true", () => {
    api.rerender('041e6958', render)
  })

}

script.__file = "src/views/registerTeam/AddTeamPage.vue"

export default script